// extracted by mini-css-extract-plugin
module.exports = {"invitedText":"VisitorsCards_invitedText__9iT20","deleteIcon":"VisitorsCards_deleteIcon__1qloe","acceptedInvite":"VisitorsCards_acceptedInvite__1A6cU"};